<template>
	<div :class="['project', centered ? 'centered' : '']" :style="{'--color': fields.infos.Color, '--mouse-x': easedMousePosition.x + 'px', '--mouse-y': easedMousePosition.y + 'px'}">
		<div :class="['video-wrapper']">
			<video ref="video" :src="fields.video.fields.file.url" muted loop></video>
		</div>
		<div class="title-container" ref="titleContainer">
			<div class="title-wrapper" ref="titleWrapper" @click="open = true">
				<div class="title pointer" ref="refTitle">
					<div class="line" v-for="(line, i) in titleArray" :key="i">
						<span v-for="(letter, j) in line" v-html="letter" :key="j" :class="letter === ' ' ? 'inline' : ''"></span>
						<br />
					</div>
				</div>
				<div class="title pointer title-stroke" ref="strokeTitle">
					<div class="line" v-for="(line, i) in titleArray" :key="i">
						<span v-for="(letter, j) in line" v-html="letter" :key="j" :class="letter === ' ' ? 'inline' : ''"></span>
						<br />
					</div>
				</div>
			</div>
		</div>
		<div class="pointer imageWrapper" ref="imageWrapper" @click="open = true">
			<img :src="cover + '?fm=jpg&q=80&fl=progressive'" alt="" ref="image">
			<video :src="fields.video.fields.file.url" alt="" ref="video" loop muted playsinline/>
		</div>
		<div class="placeholder"></div>
		<div class="gallery" ref="gallery">
			<div class="title-clone">
				<div class="title-wrapper" ref="titleCloneWrapper">
					<div class="title pointer" ref="titleClone" @click="open = true">
						<div class="line" v-for="(line, i) in titleArray" :key="i">
							<span v-for="(letter, j) in line" v-html="letter" :key="j" :class="letter === ' ' ? 'inline' : ''"></span>
							<br />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="black-filter" ref="filter" @mouseenter="hovered = true" @mousemove="hovered = true" @mouseleave="hovered = false" @click="open = false"></div>
		<div class="infos" ref="infos" :style="{top: (overlayOffset.top + overlaySize.height) + 'px', left: overlayOffset.left + 'px', 'padding-top': overlayOffset.top + 'px'}">
			<div class="infos-wrapper">
				<div class="infos-title" ref="infosTitle"><span v-html="fields.infos.Role"></span></div>
				<div class="infos-context" v-html="fields.infos.Context" ref="infosContext"></div>
				<p class="infos-description" ref="infosDescription" v-html="fields.infos.Tech"></p>
				<template v-if="fields.infos.Awards">
					<p class="infos-awards" v-html="fields.infos.Awards"></p>
				</template>
			</div>
			<template v-if="fields.url">
				<a class="infos-link" :href="fields.url" target="_blank" rel="noopener">See it live</a>
			</template>
			<template v-else-if="fields.behance">
				<a class="infos-link" :href="fields.behance" target="_blank" rel="noopener">See it on Behance</a>
			</template>
			<div class="close-button" @click="open = false" ref="closeButton">CLOSE</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		fields: {
			default: function() {
				return []
			}
		},
		centered: false
	},
	data() {
		return {
			top: 0,
			canOpenDetails: true,
			hovered: false,
			play: false,
			open: false,
			isOpenning: false,
			easedMousePosition: {
				x: window.innerWidth / 2,
				y: window.innerHeight / 2
			}
		}
	},
	computed: {
		'mousePosition': function() {
			return this.$store.getters['ui/mousePosition']
		},
		'viewportSize': function() {
			return this.$store.getters['ui/viewportSize']
		},
		'cover': function() {
			return this.fields.images.find(img => img.fields.title === 'cover').fields.file.url
		},
		'titleArray': function(){
			const lines = []
			this.fields.title.split('_').forEach(line => {
				lines.push(line.split(''))
			})
			return lines
		},
		'overlaySize': function() {
			let width = this.viewportSize.width * (this.viewportSize.width > 414 ? 0.65 : 0.85)
			let height = width / 1.77
			if (height > this.viewportSize.height * 0.7) {
				height = this.viewportSize.height * 0.7
				width = height * 1.77
			}
			return {
				width: width,
				height: height
			}
		},
		'overlayOffset': function() {
			return {
				left: (this.viewportSize.width - this.overlaySize.width) / 2,
				top: this.viewportSize.height * 0.05
			}
		}
	},
	watch: {
		'mousePosition': function(position) {
			if (this.centered) {
				this.updateMousePosition()
			}
		},
		'centered': function(centered) {
			if (centered) {
				this.showTitle()
			} else {
				this.hideTitle()
			}
		},
		'open': function(open) {
			if (open) {
				this.openDetails()
			} else {
				this.closeDetails()
			}
		},
		'hovered': function(hovered) {
			this.updateCursor()
		},
		'viewportSize': function() {
			this.updateMousePosition(0)
			if (this.open) {
				this.openDetails(0)
			} else {
				this.closeDetails(0)
			}
		}
	},
	mounted() {
		this.rect = this.$el.getBoundingClientRect()
		this.showTitle(0)
		this.hideTitle(0)
	},
	methods: {
		showTitle(duration = 1) {
			const tl = new TimelineMax()
			for (let i = 1; i <= this.$refs.titleWrapper.querySelectorAll('.title:first-child .line').length; i++) {
				const sameLines = this.$el.querySelectorAll('.line:nth-child(' + i + ')')
				sameLines.forEach(line => {
					tl.staggerTo(line.querySelectorAll('span'), 1, {
						yPercent: 0,
						y: 0,
						ease: Power4.easeOut,
						overwrite: 'preexisting'
					}, 0.02, 0)
				})
			}
			tl.to(this.$refs.image, 1.3 * duration, {
				scale: 1,
				opacity: 1,
				ease: Power4.easeOut,
				overwrite: 'preexisting'
			}, 0)
		},
		hideTitle(duration = 1) {
			const tl = new TimelineMax()
			for (let i = 1; i <= this.$refs.titleWrapper.querySelectorAll('.title:first-child .line').length; i++) {
				const sameLines = this.$el.querySelectorAll('.line:nth-child(' + i + ')')
				sameLines.forEach(line => {
					tl.staggerTo(line.querySelectorAll('span'), 1, {
						yPercent: 100,
						ease: Power4.easeOut,
						overwrite: 'preexisting'
					}, 0.03 * duration, 0)
				})
			}
			tl.to(this.$refs.image, 0.8 * duration, {
				scale: 0.95,
				opacity: 0.2,
				ease: Power4.easeOut,
				overwrite: 'preexisting'
			}, 0)
		},
		openDetails(duration = 1) {
			this.isOpenning = true
			const imageRect = this.$refs.gallery.getBoundingClientRect()
			const titleRect = this.$refs.titleClone.getBoundingClientRect()

			const tl = new TimelineMax({
				onComplete: () => {
					this.updateCursor()
					this.isOpenning = false
				}
			})

			tl
			.set(this.$refs.imageWrapper, {
				position: 'fixed',
				top: imageRect.top,
				left: imageRect.left,
				overwrite: 'preexisting',
				className: '-=pointer'
			})
			.set(this.$el, {
				'z-index': 6
			})
			.to(this.$el, 0.9 * duration, {
				'--stroke-x-1': 0,
				'--stroke-x-2': 0,
				ease: Power4.easeOut,
				overwrite: 'preexisting'
			}, 0)
			.to(this.$refs.imageWrapper, 0.7 * duration, {
				left: this.overlayOffset.left,
				top: this.overlayOffset.top,
				width: this.overlaySize.width,
				height: this.overlaySize.height,
				ease: Power4.easeOut,
				overwrite: 'preexisting'
			}, 0.35 * duration)
			.to([this.$refs.strokeTitle, this.$refs.refTitle, this.$refs.titleClone], 0.7 * duration, {
				x: this.overlayOffset.left - titleRect.left - this.viewportSize.width * 0.1,
				y: this.overlayOffset.top - titleRect.top,
				yPercent: 50,
				width: titleRect.width,
				zIndex: 5,
				ease: Power4.easeOut,
				className: '-=pointer',
				overwrite: 'preexisting'
			}, 0.35 * duration)
			.to(this.$refs.filter, 0.4 * duration, {
				opacity: 1,
				pointerEvents: 'all',
				overwrite: 'preexisting'
			}, 0.35 * duration)
			.set(this.$refs.infos, {
				opacity: 1,
				width: this.overlaySize.width,
				pointerEvents: 'all',
				overwrite: 'preexisting'
			}, 0.35 * duration)
			.staggerFromTo([this.$refs.infos, this.$refs.infosTitle, this.$refs.infosContext, this.$refs.infosDescription, this.$refs.closeButton].concat(this.$refs.infos.querySelectorAll('.infos-link, .infos-awards')), 0.7 * duration, {
				'--infos-clip-x': 100,
				'--infos-translate-x': 1
			}, {
				'--infos-clip-x': 0,
				'--infos-translate-x': 0,
				ease: Power4.easeOut,
				overwrite: 'preexisting'
			}, 0.05 * duration, 0.45 * duration)
			.add(() => {
				this.$refs.video.play()
			})
			.to(this.$refs.video, 0.5 * duration, {
				opacity: 1,
				pointerEvents: 'all',
				overwrite: 'preexisting'
			})

			if (this.$refs.infos.querySelector('.infos-link') !== null) {
				tl
				.fromTo(this.$refs.infos.querySelector('.infos-link'), 0.6 * duration, {
					'--infos-link-underline': 0
				}, {
					'--infos-link-underline': 1,
					ease: Power2.easeOut
				}, 1.1 * duration)
			}

			this.disableScroll()
		},
		closeDetails(duration = 1) {
			this.updateCursor()
			const tl = new TimelineMax({
				overwrite: 'all',
				onComplete: () => {
					this.canOpenDetails = true
				}
			})
			const imageRect = this.$refs.gallery.getBoundingClientRect()

			tl
			.staggerTo([this.$refs.infos, this.$refs.infosTitle, this.$refs.infosContext, this.$refs.infosDescription, this.$refs.closeButton].concat(this.$refs.infos.querySelectorAll('.infos-link, .infos-awards')), 0.2 * duration, {
				'--infos-clip-x': 100,
				'--infos-translate-x': 1,
				overwrite: 'preexisting'
			}, 0.03 * duration, 0)
			.add('afterText', 0.2 * duration)
			.to([this.$refs.strokeTitle, this.$refs.refTitle, this.$refs.titleClone], 0.4 * duration, {
				x: 0,
				y: 0,
				xPercent: 0,
				yPercent: -50,
				ease: Power4.easeOut,
				overwrite: 'preexisting'
			}, 'afterText')
			.to(this.$refs.imageWrapper, 0.4 * duration, {
				left: imageRect.left,
				top: imageRect.top,
				width: imageRect.width,
				height: imageRect.height,
				ease: Power4.easeOut,
				overwrite: 'preexisting',
				onComplete: () => {
					if (!this.isOpenning) {
						this.enableScroll()
					}
				}
			}, 'afterText')
			.set(this.$refs.imageWrapper, {
				clearProps: 'all',
				className: '+=pointer',
				overwrite: 'preexisting'
			})
			.to(this.$refs.filter, 0.4 * duration, {
				opacity: 0,
				pointerEvents: 'none',
				overwrite: 'preexisting'
			}, 'afterText')
			.to(this.$refs.video, 0.5 * duration, {
				opacity: 0,
				pointerEvents: 'none',
				overwrite: 'preexisting'
			}, 'afterText')
			.add(() => {
				this.$refs.video.pause()
			}, 'afterText')
			.to(this.$el, 0.9 * duration, {
				'--stroke-x-1': 100,
				'--stroke-x-2': 150,
				'z-index': 2,
				ease: Power4.easeOut,
				overwrite: 'preexisting'
			}, 'afterText+=' + 0.15 * duration)
			.set([this.$refs.strokeTitle, this.$refs.refTitle, this.$refs.titleClone], {
				clearProps: 'all',
				overwrite: 'preexisting',
				className: '+=pointer'
			})
			.set(this.$refs.infos, {
				opacity: 0,
				pointerEvents: 'none',
				overwrite: 'preexisting'
			})
		},
		disableScroll() {
			this.$store.dispatch('ui/blockOverflow')
		},
		enableScroll() {
			this.$store.dispatch('ui/unblockOverflow')
		},
		updateCursor() {
			if (this.hovered && this.open) {
				this.$store.dispatch('ui/updateCursor', 'close')
			} else {
				this.$store.dispatch('ui/updateCursor', 'default')
			}
		},
		updateMousePosition(duration = 1) {
			TweenMax.to(this.easedMousePosition, 2 * duration, {
				x: this.viewportSize.width / 2 - this.mousePosition.x,
				y: this.viewportSize.height / 2 - this.mousePosition.y,
				onUpdate: () => {
					if (this.$refs.image) {
						TweenMax.to(this.$refs.image, 0.2 * duration, {
							xPercent: -50,
							yPercent: -50,
							x: this.easedMousePosition.x / -30,
							y: this.easedMousePosition.y / -30,
							ease: Power0.easeNone
						})
					}
				}
			})
		},
		toggleVideo() {
			if (this.play) {
				this.$refs.video.pause()
				this.play = false
			} else {
				this.$refs.video.play()
				this.play = true
			}
		}
	}
}
</script>

<style lang="sass">
.project
	position: relative
	display: flex
	flex-direction: column
	justify-content: center
	align-items: flex-end
	margin: 8vh 0
	&.centered
		--opacity: 1
		z-index: 2
	.pointer
		cursor: pointer
	&:not(.centered)
		pointer-events: none
	.title-container
		.title, .title-stroke
			position: absolute
			left: calc(50vw - var(--image-width) * 0.285 - 10vw)
			top: 50%
			transform: translate(0%, -50%)
			font-size: var(--title-size) !important
			display: inline-block
			z-index: 2
			&.title-stroke
				z-index: 3
				color: transparent !important
				-webkit-text-stroke: 1px white

	.title-container, .title-clone
		font-family: var(--serif)
		.title
			line-height: 1.23
			&:nth-child(1)
				clip-path: polygon(0% 0%, calc(var(--stroke-x-1) * 1%) 0%, calc(var(--stroke-x-2) * 1%) 100%, 0% 100%)
			&:nth-child(2)
				clip-path: polygon(calc(var(--stroke-x-1) * 1%) 0%, 100% 0%, 100% 100%, calc(var(--stroke-x-2) * 1%) 100%)
			.line
				overflow: hidden
				span
					display: inline-block
					transform: translateY(100%)
					&.inline
						display: inline
	.imageWrapper
		width: var(--image-width)
		height: var(--image-height)
		left: calc(50vw - var(--image-width) * 0.285 - 2.9vw)
		overflow: hidden
		position: absolute
		z-index: 2
		img
			width: 110%
			height: 110%
			display: block
			object-fit: cover
			position: absolute
			top: 50%
			left: 50%
			opacity: 0.2
			transform: translate(-50%, -50%) scale(0.95)
		video
			position: absolute
			top: 0
			left: 0
			bottom: 0
			right: 0
			opacity: 0
			pointer-events: none
			width: 100%
			height: 100%
			object-fit: cover
	.gallery, .placeholder
		width: var(--image-width)
		height: calc(var(--image-width) / 1.7)
		margin-right: 10%
		position: relative
	.gallery
		overflow: hidden
		position: absolute
		top: 0
		left: calc(50vw - var(--image-width) * 0.285 - 2.9vw)
		margin: 0
		.title-clone
			.title, .title-stroke
				font-size: var(--title-size)
				position: absolute
				top: 50%
				left: calc((50vw - var(--image-width) * 0.285 - 10vw) - (100vw - (var(--image-width) + 10vw)))
				color: white
				transform: translate(0%, -50%)
				display: block
				z-index: 3
	.video-wrapper
		position: fixed
		padding: calc(6vw)
		top: 0
		left: 0
		right: 0
		bottom: 0
		opacity: 0
		pointer-events: none
		background-color: rgba(0, 0, 0, 0.08)
		transition: opacity 0.4s
		video
			width: 100%
			height: 100%
			object-fit: cover
			transform: scale(1.05)
			transition: transform 0.4s var(--ease)

	.black-filter
		position: fixed
		top: 0
		left: 0
		right: 0
		bottom: 0
		background-color: rgba(0,0,0,1)
		z-index: 1
		opacity: 0
		pointer-events: none
	.infos
		position: fixed
		--color: #ccc
		color: var(--color)
		z-index: 3
		opacity: 0
		pointer-events: none
		display: flex
		align-items: flex-start
		justify-content: space-between
		padding: 0em 4em
		--infos-clip-x: 100
		--infos-translate-x: 1
		@media screen and (max-width: 768px)
			padding-left: 0
			padding-right: 0
		@media screen and (max-width: 414px)
			width: 100%
			flex-direction: column
		.infos-wrapper
			padding: 0 1em
			margin-left: 5em
			width: 50rem
			position: relative
			&:before
				content: ''
				position: absolute
				right: 100%
				width: 5em
				height: 0.1em
				background-color: var(--color)
				display: block
				top: 1em
				clip-path: polygon(calc(var(--infos-clip-x) * 1%) 0%, 100% 0%, 100% 100%, calc(var(--infos-clip-x) * 1%) 100%)
				transform: translateX(calc(var(--infos-translate-x) * 2em))
				@media screen and (max-width: 768px)
					transform: rotate(90deg) translate(1.8em, -1.5em)
			@media screen and (max-width: 768px)
				margin-left: 1em
			@media screen and (max-width: 414px)
				padding: 0
				width: 100%
			.infos-title
				font-size: 1.5em
				font-family: var(--serif)
				--infos-clip-x: 100
				--infos-translate-x: 1
				clip-path: polygon(calc(var(--infos-clip-x) * 1%) 0%, 100% 0%, 100% 100%, calc(var(--infos-clip-x) * 1%) 100%)
				transform: translateX(calc(var(--infos-translate-x) * 2em))
				display: inline-block
				max-width: 66%
				@media screen and (max-width: 414px)
					margin-top: 0
					max-width: 90%
			.infos-context
				margin-top: 0.3rem
				font-weight: 700
				margin-bottom: 0
				--infos-clip-x: 100
				--infos-translate-x: 1
				clip-path: polygon(calc(var(--infos-clip-x) * 1%) 0%, 100% 0%, 100% 100%, calc(var(--infos-clip-x) * 1%) 100%)
				transform: translateX(calc(var(--infos-translate-x) * 2em))
				display: block
				text-transform: uppercase
				@media screen and (max-width: 414px)
					margin-top: 1rem
			.infos-description
				margin-bottom: 0
				--infos-clip-x: 100
				--infos-translate-x: 1
				clip-path: polygon(calc(var(--infos-clip-x) * 1%) 0%, 100% 0%, 100% 100%, calc(var(--infos-clip-x) * 1%) 100%)
				transform: translateX(calc(var(--infos-translate-x) * 2em))
				display: inline-block
				@media screen and (max-width: 414px)
					margin-top: 1rem
			.infos-awards
				margin-bottom: 0
				--infos-clip-x: 100
				--infos-translate-x: 1
				clip-path: polygon(calc(var(--infos-clip-x) * 1%) 0%, 100% 0%, 100% 100%, calc(var(--infos-clip-x) * 1%) 100%)
				transform: translateX(calc(var(--infos-translate-x) * 2em))
				display: inline-block
				@media screen and (max-width: 414px)
					margin-top: 1rem
		.infos-link
			color: var(--color)
			padding-bottom: 0.2em
			--infos-clip-x: 100
			--infos-translate-x: 1
			clip-path: polygon(calc(var(--infos-clip-x) * 1%) 0%, 100% 0%, 100% 120%, calc(var(--infos-clip-x) * 1%) 120%)
			transform: translateX(calc(var(--infos-translate-x) * 2em))
			display: inline-block
			text-decoration: none
			position: relative
			--infos-link-underline: 0
			white-space: nowrap
			@media screen and (max-width: 414px)
				margin: 2em auto
			&:before
				content: ''
				display: block
				position: absolute
				top: 100%
				left: 0
				width: 100%
				height: 0.15em
				background-color: var(--color)
				transform-origin: bottom right
				transform: scaleY(var(--infos-link-underline)) translateY(calc((1 - var(--infos-link-underline)) * 0.6em))
			&:after
				content: ''
				height: 1em
				display: inline-block
				width: 1em
				margin-left: 0.5em
				vertical-align: middle
				background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3OS45IDc5LjkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiIgdGV4dC1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiIgaW1hZ2UtcmVuZGVyaW5nPSJvcHRpbWl6ZVF1YWxpdHkiPiAgPHBhdGggZmlsbD0iI2JiYiIgZD0iTTU0IDkuNEE0LjcgNC43IDAgMCAxIDU0IDBoMjEuMkM3Ny44IDAgODAgMi4xIDgwIDQuN3YyMS4yYTQuNyA0LjcgMCAwIDEtOS40IDBWMTZMNDMuMyA0My4zYTQuNyA0LjcgMCAwIDEtNi43LTYuN0w2NCA5LjRINTR6bTE2LjUgMzUuM2E0LjcgNC43IDAgMCAxIDkuNCAwdjMwLjVjMCAyLjYtMiA0LjctNC43IDQuN0g0LjdBNC43IDQuNyAwIDAgMSAwIDc1LjJWNC43QzAgMi4xIDIuMSAwIDQuNyAwaDMwLjZhNC43IDQuNyAwIDAgMSAwIDkuNEg5LjR2NjEuMWg2MS4xVjQ0Ljd6IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=)
				background-size: cover
		.close-button
			color: var(--color)
			font-weight: bold
			text-transform: uppercase
			margin: 2rem auto
			visibility: hidden
			font-size: 1.3rem
			position: absolute
			top: 100%
			left: 50%
			transform: translateX(-50%)
			clip-path: polygon(calc(var(--infos-clip-x) * 1%) 0%, 100% 0%, 100% 120%, calc(var(--infos-clip-x) * 1%) 120%)
			@media (pointer: coarse) and (hover: none)
				visibility: visible
</style>



// WEBPACK FOOTER //
// src/components/Project.vue